import { cosemApi } from '@services/providers/cosem';
import {
    SendNotificationPayload,
    SendNotificationToMemberPayload,
    SendNotificationToMembersPayload,
    SendNotificationResponse,
    TokenStats,
    NotificationHistoryTable,
    NotificationHistoryDetail
} from './notification.types';
import { ApiResponse, ApiPaginationResponse } from '@services/providers/cosem.types';
import { ActiveFilter } from '@utils/filters';

const notificationApi = cosemApi.injectEndpoints({
    endpoints: (build) => ({
        sendNotificationToAll: build.mutation<ApiResponse<SendNotificationResponse>, SendNotificationPayload>({
            query: (payload) => ({
                url: `/member/notifications/send-to-all`,
                method: 'POST',
                body: payload
            }),
            transformResponse: (response: ApiResponse<SendNotificationResponse>) => response
        }),
        sendNotificationToMember: build.mutation<ApiResponse<SendNotificationResponse>, SendNotificationToMemberPayload>({
            query: (payload) => ({
                url: `/member/notifications/send-to-member`,
                method: 'POST',
                body: payload
            }),
            transformResponse: (response: ApiResponse<SendNotificationResponse>) => response
        }),
        sendNotificationToMembers: build.mutation<ApiResponse<SendNotificationResponse>, SendNotificationToMembersPayload>({
            query: (payload) => ({
                url: `/member/notifications/send-to-members`,
                method: 'POST',
                body: payload
            }),
            transformResponse: (response: ApiResponse<SendNotificationResponse>) => response
        }),
        getTokenStats: build.mutation<ApiResponse<TokenStats>, void>({
            query: () => ({
                url: `/member/notifications/stats`,
                method: 'GET'
            }),
            transformResponse: (response: ApiResponse<TokenStats>) => response
        }),
        getNotificationHistories: build.mutation<
            ApiPaginationResponse<NotificationHistoryTable>,
            { limit?: number; page?: number; search?: string; orderBy?: string; filters?: ActiveFilter[] }
        >({
            query: ({ limit = 10, page = 1, search, orderBy, filters }) => ({
                url: `/member/notifications/history`,
                method: 'GET',
                params: {
                    limit,
                    page,
                    search: search ?? '',
                    orderBy: orderBy ?? '',
                    filters: JSON.stringify(filters ?? [])
                }
            }),
            transformResponse: (response: ApiPaginationResponse<NotificationHistoryTable>) => response
        }),
        getNotificationHistory: build.mutation<ApiResponse<NotificationHistoryDetail>, { id: number | string }>({
            query: ({ id }) => ({
                url: `/member/notifications/history/${id}`,
                method: 'GET'
            }),
            transformResponse: (response: ApiResponse<NotificationHistoryDetail>) => response
        })
    })
});

export const {
    useSendNotificationToAllMutation,
    useSendNotificationToMemberMutation,
    useSendNotificationToMembersMutation,
    useGetTokenStatsMutation,
    useGetNotificationHistoriesMutation,
    useGetNotificationHistoryMutation
} = notificationApi;
